export class FileHelper {
    public static getFileExtension(fullFileName: string): string {
        return fullFileName.split('.').pop();
    }

    public static getFileName(fullFileName: string): string {
        return fullFileName.split('.').slice(0, -1).join('.');
    }
}
